import { useEffect, useRef, useState } from "react";
import { Button, Card, Form, Nav, Navbar, Spinner, Table } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import {
    BrowserRouter as Router, Route, Switch, useParams, useRouteMatch
} from "react-router-dom";
import { db } from '../../../firebase';
import Match from "./match";


/*
@params DAY MATCH RUBBER 
    1. Display all MATCHes on this date
    2. Each MATCH consists all results between 2 teams
    3. Each RUBBER contains all results of 2 oppositions e.g. if A and B play 5 sets, results of all 5 sets will go into the same RUBBER
*/
export default function Day(props) {
    let { id } = useParams()
    let routeMatch = useRouteMatch()

    let [loading, setLoading] = useState(true)
    let [onDel, setOnDel] = useState(false)
    let [onAddMatch, setonAddMatch] = useState(false)
    let [allMatches, setallMatches] = useState([])
    let [availablePlys, setavailablePlys] = useState([])


    let nameRef = useRef()
    let timeRef = useRef()

    let matchesDBRef = db.collection("seasons").doc(props.seasonID)
        .collection("days").doc(id).collection("matches")

    let dayDBRef = db.collection("seasons").doc(props.seasonID)
        .collection("days").doc(id)

    let availabilityDBRef = dayDBRef.collection("availability")


    // delete this day
    function handleDelete() {
        setOnDel(true)
    }

    function handleCancel() {
        setOnDel(false)
    }

    function handleConfDel() {
        dayDBRef.delete()
            .then(() => {
                console.log("day document deleted!!!")
                props.reloadDays()
                setOnDel(false)
            }).catch((e) => {
                console.log(e)
            })
    }


    // modify matches
    function handleAddMatch() {
        setonAddMatch(true)
    }

    function handleCancelAddMatch() {
        setonAddMatch(false)
    }

    function handleConfAddMatch() {
        setLoading(true)
        if (nameRef.current.value) {
            matchesDBRef.add({
                name: nameRef.current.value,
                time: timeRef.current.value
            })
                .then((docRecord) => {
                    console.log(`Document created with id ${docRecord.id}`)
                    getAllMatches()
                    props.reloadDays()
                    setonAddMatch(false)
                })
                .catch((e) => {
                    console.log(e)
                    setonAddMatch(false)
                    setLoading(false)
                })
        }
    }

    function getAllMatches() {
        setLoading(true)
        matchesDBRef.get()
            .then((querySnapshot) => {
                var resMatches = []
                querySnapshot.forEach((doc) => {
                    let matchObj = doc.data()
                    matchObj.id = doc.id
                    resMatches.push(matchObj)
                })
                resMatches = sortMatches(resMatches)
                setallMatches(resMatches)
                setLoading(false)
            })
            .catch((e) => {
                console.log(e)
                setLoading(false)
            })
    }

    function sortMatches(days) {
        days.sort(function (a, b) {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            return new Date(b.date) - new Date(a.date);
        });
        return days
    }

    // available players
    function getavailablePlys() {
        availabilityDBRef.get()
            .then((querySnapShot) => {
                var newplayerPool = []
                querySnapShot.forEach((doc) => {
                    let data = doc.data()
                    var player = {
                        displayName: data.displayName,
                        uid: data.uid,
                        id: doc.id,
                    }
                    newplayerPool.push({ player })
                })
                console.log("player pool: ", newplayerPool)
                setavailablePlys(newplayerPool)
            })
            .catch((e) => {
                console.log(e)
            })
    }


    useEffect(() => {
        getAllMatches()
        getavailablePlys()
    }, [id])

    const displayallMatches = (
        allMatches.map((day, ind) => {
            return (
                <div key={ind}>
                    <LinkContainer to={`${routeMatch.url}/matches/${day.id}`}>
                        <Nav.Link>
                            <b>{day.name}</b>
                            <br></br>
                            <span>{day.time}</span>
                        </Nav.Link>
                    </LinkContainer>

                </div>
            )
        })
    )

    const displayAvailablePlys = availablePlys.map((player, ind) => {
        return (
            <tr>
                <td>{player.player.displayName}</td>
            </tr>
        )
    })

    const displayDay = (
        <div id="container">
            {onDel ?
                <div>
                    <span>Do you want to delete this day?</span>
                    <Button variant="outline-secondary" onClick={handleCancel}>Cancel</Button>
                    <Button variant="danger" onClick={handleConfDel}>Delete</Button>
                </div>
                : <Button variant="danger" onClick={handleDelete}>Delete this day</Button>}

            <div id="container">
                <Navbar
                    variant="dark"
                    className="navbar"
                >
                    <Nav>
                        <h5 className="light-text">Matches</h5>
                        {displayallMatches}
                    </Nav>
                </Navbar>

                {onAddMatch ?
                    <div>
                        <Card>
                            <Card.Body>
                                <Form>
                                    <Form.Group>
                                        <Form.Label>Name</Form.Label>
                                        <Form.Control type="text" ref={nameRef} placeholder="give this match a name"></Form.Control>
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>Time</Form.Label>
                                        <Form.Control type="time" ref={timeRef} ></Form.Control>
                                    </Form.Group>
                                </Form>
                            </Card.Body>
                        </Card>

                        <Button variant="light" onClick={handleCancelAddMatch}>Cancel</Button>
                        <Button onClick={handleConfAddMatch}>Save</Button>
                    </div>
                    :
                    <Button onClick={handleAddMatch}>+ add match</Button>
                }
            </div>



            <div>
                <Card className="center scoreboard">
                    <Card.Body>
                        <Table className="" striped bordered hover size="sm">
                            <thead>
                                <tr>
                                    <th>Available Players</th>
                                </tr>
                            </thead>
                            <tbody>
                                {displayAvailablePlys}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            </div>
        </div>
    )



    return (
        <div>
            <Router>
                {loading ? <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                </Spinner> : displayDay}
                <Switch>
                    <Route path={`${routeMatch.url}/matches/:id`}>
                        <Match seasonID={props.seasonID} dayID={id} reloadMatches={getAllMatches} />
                    </Route>
                </Switch>
            </Router>
        </div>
    )

}